module.exports = (require("./helpers/browser/import-polyfill")(parcelRequire.resolve("lu6ot"))).then(() => parcelRequire('fBRI3'));